// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapperDiv":"Upload_uploadWrapperDiv__rO7lh","uploadPreviewDiv":"Upload_uploadPreviewDiv__1wNg5","uploadButton":"Upload_uploadButton__D7rnu"};